import React, { useState } from 'react';
import IconAdd from '../images/IconAdd.jsx';
import CompanyCarousel from './CompanyCarousel.jsx';

const ContactCompanies = ({ fields, append, control, clearErrors, remove, update, hideSearch }) => {
    const [addNew, setAddNew] = useState(false);

    return (
        <>
            <div className='mb-4 text-theme1-primary font-bold text-xl flex justify-between'>
                <span>Companies</span>
                <span className='cursor-pointer' onClick={() => setAddNew(true)}>
                    <IconAdd className='fill-theme1-text1' />
                </span>
            </div>
            <div className='mb-10'>
                <CompanyCarousel
                    items={fields}
                    className='mb-6'
                    edit
                    control={control}
                    clearErrors={clearErrors}
                    removeItem={remove}
                    addNew={addNew}
                    setAddNew={setAddNew}
                    update={update}
                    append={append}
                    hideSearch={hideSearch}
                />
            </div>
        </>
    );
};

export default ContactCompanies;
